<template>
  <stage-card-info-list>
    <template #header>Forecast</template>
    <template #content>
      <bubble-info-list-item :bubble-text="estimatedRelevantText">
        Estimated Remaining Relevant
      </bubble-info-list-item>
    </template>
  </stage-card-info-list>
</template>

<script>
import StageCardInfoList from '@/components/DashboardTab/StageCardInfoList';
import BubbleInfoListItem from '@/components/DashboardTab/BubbleInfoListItem';
import { Review } from '@/models';

export default {
  name: 'ScreeningForecast',
  components: {
    StageCardInfoList,
    BubbleInfoListItem,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    estimatedRelevantText() {
      const { remainingRelevantAnalysis } = this.review;
      const { total } = remainingRelevantAnalysis ?? {};
      if (!total) return '-';
      return `${total.upperRangeCount} - ${total.lowerRangeCount}`;
    },
  },
};
</script>
